import {
    apiRequest,
    riwayatangkakreditUpdate,
    riwayatangkakreditDetail,
    masterPosition,
    masterEchelon,
    masterPositionStatus,
    masterWorkUnit,
    masterSignatoryOfficial
} from "../../../../../../services/adapters/kepegawaian/riwayatangkakreditService"

class UpdateRepository {

    fetchUpdate = async (query) => {
        return await apiRequest("post", riwayatangkakreditUpdate, {
            body: query
        }, true)
    }

    
    fetchPosition = async (query) => {
        return await apiRequest("get", masterPosition, {
            params: query
        }, true)
    }

    fetchEselon = async (query) => {
        return await apiRequest("get", masterEchelon, {
            params: query
        }, true)
    }

    fetchPositionStatus = async (query) => {
        return await apiRequest("get", masterPositionStatus, {
            params: query
        }, true)
    }

    fetchWorkUnit = async (query) => {
        return await apiRequest("get", masterWorkUnit, {
            params: query
        }, true)
    }

    fetchSignatoryOfficial = async (query) => {
        return await apiRequest("get", masterSignatoryOfficial, {
            params: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", riwayatangkakreditDetail, {
            params: query
        }, true)
    }

}

export default UpdateRepository